export function ContentSubmitting() {
  return (
    <div class="flex flex-col items-center justify-center gap-5 px-6 py-24 font-theme animate-[fv-viewIn_0.35s_cubic-bezier(0.2,0.7,0.2,1)_both]">
      <div class="relative w-12 h-12 flex items-center justify-center">
        <svg class="w-12 h-12 animate-[fv-spin_1s_linear_infinite]" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="20" stroke="var(--fv-theme-border, #e2e6ec)" stroke-width="3" />
          <path
            d="M44 24a20 20 0 00-20-20"
            stroke="var(--fv-theme-primary, #007145)"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="text-center max-w-[320px]">
        <h3 class="m-0 mb-2 text-lg font-semibold tracking-[-0.02em] text-theme-fg">
          Saving your details...
        </h3>
        <p class="m-0 text-[13.5px] text-theme-muted-fg leading-relaxed">
          Just a moment while we save your information.
        </p>
      </div>
    </div>
  );
}
